import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const useAuth = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            axios.get('https://api.theonlysale.com/api/validate-token', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(response => {
                if (response.status === 200) {
                    setUser(response.data.user); 
                } else {
                    navigate('/login'); 
                }
            }).catch(error => {
                console.error("Token validation failed:", error);
                navigate('/login'); 
            });
        } else {
            navigate('/login'); 
        }
    }, [navigate]);

    return user;
};

export default useAuth;
